import { Button, Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { EInvoicesKYCRefusedStatus } from '../../../../assets/images'
import { E_INVOICING_STEP_TO_PATH } from '../../../eInvoicing/constants'
import { getEInvoicingBaseUrl } from '../../utils'
import { EInvoicingGenericStatus } from '../EInvoicingGenericStatus'

export const EInvoicingKYCRefused = (): ReactElement => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()

  return (
    <EInvoicingGenericStatus
      title={t('e_invoice.kyc.step.status.refused.title')}
      illustration={EInvoicesKYCRefusedStatus}
    >
      <Text colorVariant="secondary" alignment="center">
        {t('e_invoice.kyc.step.status.refused.footer')}
      </Text>
      <Space size="s24" />
      <Button fullWidth to={`${getEInvoicingBaseUrl(organization)}/${E_INVOICING_STEP_TO_PATH.COMPANY_INFO}`}>
        {t('e_invoice.kyc.step.status.refused.cta.primary')}
      </Button>
    </EInvoicingGenericStatus>
  )
}
